import React, { useEffect } from 'react';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { Paper } from '@mui/material';
import classes from './index.module.css';
export default function RedirectPage({}) {
  useEffect(() => {
    function redirect(questionId: any) {
      const URL = `${process.env.REACT_APP_HH_APP_ENDPOINT}/assessment/createcodingquestion?questionId=${questionId}&role=interviewer&tab=3`;
      window.location.href = URL;
    }
    const params = new URLSearchParams(window.location.search);
    const questionId = params.get('questionId');
    let timer = setTimeout(() => {
      redirect(questionId);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div className={classes.container}>
      <CheckCircleIcon
        style={{
          color: '#4CAF50',
          width: '80px',
          height: '80px',
          margin: '0px 8px',
        }}
      />
      <div>
        <p className={classes.textContainer}>
          Test Cases passed Successfully! Redirecting to Interviewer page...
        </p>
      </div>
    </div>
  );
}
